import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { BarChart3, Download, Edit2, FileJson, FileText, Folder } from 'lucide-react';

export default function CategoriesInfoDialogs({
  viewDialogOpen, setViewDialogOpen,
  exportDialogOpen, setExportDialogOpen,
  statsDialogOpen, setStatsDialogOpen,
  currentCategory, stats, handleExport, getColorClass
}) {
  return (
    <>
      <Dialog open={viewDialogOpen} onOpenChange={setViewDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Détails de la catégorie</DialogTitle>
          </DialogHeader>
          {currentCategory && (
            <div className="space-y-4 py-4">
              <div className="flex items-center gap-3">
                <div className={`p-3 rounded-lg ${getColorClass(currentCategory.color)}`}>
                  <Folder className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold">{currentCategory.name}</h2>
                  <Badge variant="outline" className="font-mono bg-slate-700 text-white border-slate-800 font-semibold">{currentCategory.code}</Badge>
                </div>
              </div>
              {currentCategory.description && (
                <p className="text-slate-600">{currentCategory.description}</p>
              )}
              <div className="grid grid-cols-2 gap-4">
                <div className="p-3 bg-slate-50 rounded-lg">
                  <Label className="text-xs text-slate-500">Nomenclatures</Label>
                  <p className="font-semibold">{currentCategory.nomenclatures_count || 0}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg">
                  <Label className="text-xs text-slate-500">Ordre</Label>
                  <p className="font-semibold">{currentCategory.order}</p>
                </div>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setViewDialogOpen(false)}>Fermer</Button>
            <Button onClick={() => { setViewDialogOpen(false); openEditDialog(currentCategory); }}>
              <Edit2 className="h-4 w-4 mr-2" /> Modifier
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Export */}
      <Dialog open={exportDialogOpen} onOpenChange={setExportDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Download className="h-5 w-5" /> Exporter les catégories
            </DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4 py-6">
            <Button variant="outline" className="h-24 flex-col gap-2" onClick={() => handleExport('json')}>
              <FileJson className="h-8 w-8 text-amber-600" />
              <span>JSON</span>
            </Button>
            <Button variant="outline" className="h-24 flex-col gap-2" onClick={() => handleExport('csv')}>
              <FileText className="h-8 w-8 text-green-600" />
              <span>CSV</span>
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Stats */}
      <Dialog open={statsDialogOpen} onOpenChange={setStatsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <BarChart3 className="h-5 w-5" /> Statistiques
            </DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4 py-4">
            <Card className="p-4 bg-gradient-to-br from-emerald-50 to-emerald-100">
              <div className="text-3xl font-bold text-emerald-700">{stats.total}</div>
              <div className="text-sm text-emerald-600">Total catégories</div>
            </Card>
            <Card className="p-4 bg-gradient-to-br from-green-50 to-green-100">
              <div className="text-3xl font-bold text-green-700">{stats.active}</div>
              <div className="text-sm text-green-600">Actives</div>
            </Card>
            <Card className="p-4 bg-gradient-to-br from-blue-50 to-blue-100">
              <div className="text-3xl font-bold text-blue-700">{stats.withNomenclatures}</div>
              <div className="text-sm text-blue-600">Avec nomenclatures</div>
            </Card>
            <Card className="p-4 bg-gradient-to-br from-slate-50 to-slate-100">
              <div className="text-3xl font-bold text-slate-700">{stats.archived}</div>
              <div className="text-sm text-slate-600">Archivées</div>
            </Card>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
